module.exports = __webpack_public_path__ + "img/stock7.16e33c85.png";